var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1611 0.661165C0.380052 1.44221 0.380051 2.70854 1.1611 3.48959L7.17151 9.5L1.1611 15.5104C0.380051 16.2915 0.380051 17.5578 1.1611 18.3388C1.94215 19.1199 3.20848 19.1199 3.98953 18.3388L9.99993 12.3284L16.0103 18.3388C16.7914 19.1199 18.0577 19.1199 18.8388 18.3388C19.6198 17.5578 19.6198 16.2915 18.8388 15.5104L12.8284 9.5L18.8388 3.48959C19.6198 2.70854 19.6198 1.44221 18.8388 0.661165C18.0577 -0.119883 16.7914 -0.119884 16.0103 0.661165L9.99993 6.67157L3.98953 0.661165C3.20848 -0.119883 1.94215 -0.119883 1.1611 0.661165Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossModal);
export default __webpack_public_path__ + "static/media/cross-modal.6f27deb05b4333e7d7ce948cc1f55eb6.svg";
export { ForwardRef as ReactComponent };